import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.updateInvitation
)

export const selectDeleteInvitationModalOpen = createSelector(
    baseSelector,
    (state) => state.isDeleteInvitationModalOpen
)

export const selectCreateInvitationModalOpen = createSelector(
    baseSelector,
    (state) => state.isCreateInvitationModalOpen
)

export const selectInspectInvitationModalOpen = createSelector(
    baseSelector,
    (state) => state.isInspectInvitationModalOpen
)

export const selectOnDelete = createSelector(
    baseSelector,
    (state) => state.onDelete
)

export const selectOnCreate = createSelector(
    baseSelector,
    (state) => state.onCreate
)

export const selectCurrentInvitation = createSelector(
    baseSelector,
    (state) => state.currentInvitation
)

export const selectCurrentRole = createSelector(
    baseSelector,
    (state) => state.role
)